import { createSlice } from "@reduxjs/toolkit";

const initialMenuState = {
  listLoading: false,
  faqs: { openedProducts: [] },
  videos: { openedProducts: [] },
  manuals: { openedProducts: [] },
  updates: { openedProducts: [] },
  links: { openedProducts: [] },
  newsletters: { openedProducts: [] },
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const menuSlice = createSlice({
  name: "menu",
  initialState: initialMenuState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.listLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      state.listLoading = true;
    },
    faqsFetched: (state, action) => {
      state.faqs[action.payload.module] = (action.payload.items ?? []).map(
        ({ id, title }) => ({
          id,
          title,
        })
      );

      state.listLoading = false;
      state.error = null;
    },
    videosFetched: (state, action) => {
      state.videos[action.payload.module] = (action.payload.items ?? []).map(
        ({ id, title }) => ({
          id,
          title,
        })
      );

      state.listLoading = false;
      state.error = null;
    },
    manualsFetched: (state, action) => {
      state.manuals[action.payload.module] = (action.payload.items ?? []).map(
        ({ id, title }) => ({
          id,
          title,
        })
      );

      state.listLoading = false;
      state.error = null;
    },
    updatesFetched: (state, action) => {
      state.updates[action.payload.module] = (action.payload.items ?? []).map(
        ({ id, title }) => ({
          id,
          title,
        })
      );

      state.listLoading = false;
      state.error = null;
    },
    linksFetched: (state, action) => {
      state.links[action.payload.module] = (action.payload.items ?? []).map(
        ({ id, title }) => ({
          id,
          title,
        })
      );

      state.listLoading = false;
      state.error = null;
    },
    newslettersFetched: (state, action) => {
      state.newsletters[action.payload.module] = (
        action.payload.items ?? []
      ).map(({ id, title }) => ({
        id,
        title,
      }));

      state.listLoading = false;
      state.error = null;
    },
    // -------------
    setFaqOpenedProductMenu: (state, action) => {
      state.faqs = {
        ...state.faqs,
        openedProducts: action.payload.productIds,
        openedModule: action.payload.moduleId,
      };

      state.videos = { openedProducts: [] };
      state.manuals = { openedProducts: [] };
      state.updates = { openedProducts: [] };
      state.links = { openedProducts: [] };
      state.newsletters = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
    setVideosOpenedProductMenu: (state, action) => {
      state.videos = {
        ...state.videos,
        openedProducts: action.payload.productIds,
        openedModule: action.payload.moduleId,
      };

      state.faqs = { openedProducts: [] };
      state.manuals = { openedProducts: [] };
      state.updates = { openedProducts: [] };
      state.links = { openedProducts: [] };
      state.newsletters = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
    setManualsOpenedProductMenu: (state, action) => {
      state.manuals = {
        ...state.manuals,
        openedProducts: action.payload.productIds ?? [],
        openedModule: action.payload.moduleId ?? [],
      };

      state.faqs = { openedProducts: [] };
      state.videos = { openedProducts: [] };
      state.updates = { openedProducts: [] };
      state.links = { openedProducts: [] };
      state.newsletters = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
    setUpdatesOpenedProductMenu: (state, action) => {
      state.updates = {
        ...state.updates,
        openedProducts: action.payload.productIds,
        openedModule: action.payload.moduleId,
      };

      state.faqs = { openedProducts: [] };
      state.videos = { openedProducts: [] };
      state.manuals = { openedProducts: [] };
      state.links = { openedProducts: [] };
      state.newsletters = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
    setLinksOpenedProductMenu: (state, action) => {
      state.links = {
        ...state.links,
        openedProducts: action.payload.productIds,
        openedModule: action.payload.moduleId,
      };

      state.faqs = { openedProducts: [] };
      state.videos = { openedProducts: [] };
      state.manuals = { openedProducts: [] };
      state.updates = { openedProducts: [] };
      state.newsletters = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
    setNewslettersOpenedProductMenu: (state, action) => {
      state.newsletters = {
        ...state.newsletters,
        openedProducts: action.payload.productIds,
        openedModule: action.payload.moduleId,
      };

      state.faqs = { openedProducts: [] };
      state.videos = { openedProducts: [] };
      state.manuals = { openedProducts: [] };
      state.updates = { openedProducts: [] };
      state.links = { openedProducts: [] };

      state.listLoading = false;
      state.error = null;
    },
  },
});
